import React from "react";
import { Chip, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {
  Edit as DraftIcon,
  AccessTime as PendingIcon,
  Visibility as ReviewIcon,
  CheckCircle as ApprovedIcon,
  Cancel as RejectedIcon,
  Schedule as ExpiredIcon,
  Block as CancelledIcon,
} from "@material-ui/icons";

const styles = (theme) => ({
  draft: {
    backgroundColor: theme.palette.grey[500],
    color: "white",
  },
  pending: {
    backgroundColor: "#ff9800",
    color: "white",
  },
  inReview: {
    backgroundColor: "#2196f3",
    color: "white",
  },
  approved: {
    backgroundColor: "#4caf50",
    color: "white",
  },
  rejected: {
    backgroundColor: "#f44336",
    color: "white",
  },
  expired: {
    backgroundColor: "#ff5722",
    color: "white",
  },
  cancelled: {
    backgroundColor: theme.palette.grey[600],
    color: "white",
  },
});

const getStatusIcon = (status) => {
  switch (status) {
    case "DRAFT":
      return <DraftIcon />;
    case "PENDING":
      return <PendingIcon />;
    case "IN_REVIEW":
      return <ReviewIcon />;
    case "APPROVED":
      return <ApprovedIcon />;
    case "REJECTED":
      return <RejectedIcon />;
    case "EXPIRED":
      return <ExpiredIcon />;
    case "CANCELLED":
      return <CancelledIcon />;
    default:
      return <DraftIcon />;
  }
};

const getStatusDescription = (status) => {
  switch (status) {
    case "DRAFT":
      return "Enrollment is in draft status and can be edited";
    case "PENDING":
      return "Enrollment is pending review";
    case "IN_REVIEW":
      return "Enrollment is currently being reviewed";
    case "APPROVED":
      return "Enrollment has been approved";
    case "REJECTED":
      return "Enrollment has been rejected";
    case "EXPIRED":
      return "Enrollment approval has expired";
    case "CANCELLED":
      return "Enrollment has been cancelled";
    default:
      return "Unknown status";
  }
};

const getStatusLabel = (status) => {
  switch (status) {
    case "DRAFT":
      return "Draft";
    case "PENDING":
      return "Pending Review";
    case "IN_REVIEW":
      return "In Review";
    case "APPROVED":
      return "Approved";
    case "REJECTED":
      return "Rejected";
    case "EXPIRED":
      return "Expired";
    case "CANCELLED":
      return "Cancelled";
    default:
      return status;
  }
};

const EnrollmentStatusBadge = ({
  classes,
  status,
  size = "medium",
  className,
}) => {
  const statusKey = (status || "DRAFT").toLowerCase().replace(/_/g, "");
  // draft | pending | inreview | approved | rejected | expired | cancelled
  const classMap = {
    draft: classes.draft,
    pending: classes.pending,
    inreview: classes.inReview,
    approved: classes.approved,
    rejected: classes.rejected,
    expired: classes.expired,
    cancelled: classes.cancelled,
  };
  const chipClass = classMap[statusKey] || classes.draft;

  return (
    <Tooltip title={getStatusDescription(status)} arrow>
      <Chip
        icon={getStatusIcon(status)}
        label={getStatusLabel(status)}
        size={size}
        className={`${chipClass} ${className}`}
        variant="filled"
      />
    </Tooltip>
  );
};

export default withStyles(styles)(EnrollmentStatusBadge);
